import { IFrameInfo } from '../main/frameInfo'
import { frameInfo } from '../main/frameInfo-sidecar'
import { ICargoType } from '../entities/cargoesData'

export type IMachineType =
  | 'error'
  | 'water-cooler'
  | 'ice-melter'
  | 'suits'
  | 'airlock'
  | 'airlock2'
  | 'grower'
  | 'bed'
  | 'table'
  | 'o2gen'
  | 'o2gen-em'
  | 'co2scrubber'
  | 'reactor-em'
  | 'reactor'
  | 'engine'
  | 'door'
  | 'pile'
  | 'stack'

export type MachinePlaceRuleType = 'hull' | 'floor' | 'space'
export interface IMachinePlaceRule {
  oi: number
  oj: number
  type: MachinePlaceRuleType
  hasPart: boolean
}
const createPlaceRule = (
  oi: number,
  oj: number,
  type: MachinePlaceRuleType,
  hasPart: boolean,
): IMachinePlaceRule => {
  return {
    oi,
    oj: -oj,
    type,
    hasPart,
  }
}

export interface IMachinePartData {
  oi: number
  oj: number
  name?: string
  core?: boolean
  frames: IFrameInfo[]
  isDefaultBacking?: boolean
}

export interface IBuildRequirement {
  cargoType: ICargoType
  num: number
}
const createBuildRequirement = (
  cargoType: ICargoType,
  num: number = 1,
): IBuildRequirement => {
  return {
    cargoType,
    num,
  }
}

export interface IMachineData {
  idx: number
  type: IMachineType
  frames: IFrameInfo[]
  buildName: string
  buildDesc: string
  parts: IMachinePartData[] | null
  placeRules: IMachinePlaceRule[]
  allowBuild: boolean
  ox: number
  oy: number
  isStack: boolean
  stackMaxSize: number
  upperLeftOi: number
  upperLeftOj: number
  buildRequirements: IBuildRequirement[]
}

const defaultData: IMachineData = {
  idx: -1,
  type: 'error',
  frames: [frameInfo.fi32(5, 1, 9)],
  buildDesc: 'Unknown',
  buildName: 'Unk',
  ox: 0,
  oy: 0,
  placeRules: [],
  isStack: false,
  stackMaxSize: 0,
  upperLeftOi: 0,
  upperLeftOj: 0,
  allowBuild: true,
  buildRequirements: [
    {
      cargoType: 'steel',
      num: 1,
    },
  ],
  parts: [],
  // parts: [
  //   {
  //     oi: 0,
  //     oj: 0,
  //     core: true,
  //     name: 'core',
  //     frames: [frameInfo.fi32(5, 1, 9)],
  //   },
  // ],
}

export const dataList: IMachineData[] = []
export const dataMapIdx: { [key: number]: IMachineData } = {}
export const dataMapName: { [key: string]: IMachineData } = {}

const frameInfoMachineBack = frameInfo.fi32(8, 6, 1)

export function addMachine(
  type: IMachineType,
  data: Partial<IMachineData>,
  placeRules: IMachinePlaceRule[],
  parts: IMachinePartData[] | null = null,
) {
  let idx = dataList.length

  if (parts === null) {
    parts = []
  }
  for (let i = 0; i < placeRules.length; i++) {
    let pr = placeRules[i]
    if (!pr.hasPart) {
      continue
    }

    let hasFoundPart = false

    for (let j = 0; j < parts.length; j++) {
      let p = parts[j]
      if (p.oi === pr.oi && p.oj === pr.oj) {
        hasFoundPart = true
        break
      }
    }

    if (hasFoundPart) {
      continue
    }

    // No part, add it
    parts.push({
      frames: [frameInfoMachineBack],
      oi: pr.oi,
      oj: pr.oj,
      isDefaultBacking: true,
    })
  }

  let uloi = 0
  let uloj = 0
  console.log('parts', type, parts)
  for (let i = 0; i < parts.length; i++) {
    let p = parts[i]
    if (p.oi < uloi) {
      uloi = p.oi
    }
    if (p.oj < uloj) {
      uloj = p.oj
    }
  }

  let d: IMachineData = Object.assign({}, defaultData, data, {
    idx,
    type,
    parts,
    placeRules,
    upperLeftOi: uloi,
    upperLeftOj: uloj,
  })
  // if (parts) {
  //   d.parts = parts
  // }
  // } else {
  //   d.parts[0].frames = d.frames
  // }

  Object.freeze(d)
  dataList.push(d)

  dataMapIdx[idx] = d
  dataMapName['' + type] = d
}

const x1x1 = [
  createPlaceRule(0, 0, 'floor', true),
  createPlaceRule(0, -1, 'hull', false),
]
const x1x2 = [
  createPlaceRule(0, 1, 'floor', true),
  createPlaceRule(0, 0, 'floor', true),
  createPlaceRule(0, -1, 'hull', false),
]

const door = [
  createPlaceRule(0, 1, 'floor', true),
  createPlaceRule(0, 0, 'floor', true),
  createPlaceRule(0, -1, 'hull', false),
  createPlaceRule(0, 2, 'hull', false),
]

const airlock = [
  createPlaceRule(-1, 1, 'hull', true),
  createPlaceRule(-1, 0, 'hull', true),
  createPlaceRule(-1, -1, 'hull', false),
  createPlaceRule(-1, 2, 'hull', false),
  createPlaceRule(0, 1, 'floor', true),
  createPlaceRule(0, 0, 'floor', true),
  createPlaceRule(0, -1, 'hull', false),
  createPlaceRule(0, 2, 'hull', false),

  createPlaceRule(1, 1, 'floor', true),
  createPlaceRule(1, 0, 'floor', true),
  createPlaceRule(1, -1, 'hull', false),
  createPlaceRule(1, 2, 'hull', false),
]
const x2x1 = [
  createPlaceRule(0, 0, 'floor', true),
  createPlaceRule(0, -1, 'hull', false),
  createPlaceRule(1, 0, 'floor', true),
  createPlaceRule(1, -1, 'hull', false),
]
const x2x2 = [
  createPlaceRule(0, 0, 'floor', true),
  createPlaceRule(0, 1, 'floor', true),
  createPlaceRule(0, -1, 'hull', false),
  createPlaceRule(1, 0, 'floor', true),
  createPlaceRule(1, 1, 'floor', true),
  createPlaceRule(1, -1, 'hull', false),
]

const x4x2 = [
  createPlaceRule(0, 0, 'floor', true),
  createPlaceRule(0, 1, 'floor', true),
  createPlaceRule(0, -1, 'hull', false),
  createPlaceRule(1, 0, 'floor', true),
  createPlaceRule(1, 1, 'floor', true),
  createPlaceRule(1, -1, 'hull', false),
  createPlaceRule(2, 0, 'floor', true),
  createPlaceRule(2, 1, 'floor', true),
  createPlaceRule(2, -1, 'hull', false),
  createPlaceRule(3, 0, 'floor', true),
  createPlaceRule(3, 1, 'floor', true),
  createPlaceRule(3, -1, 'hull', false),
]

const xEngine = [
  createPlaceRule(0, 0, 'hull', true),
  createPlaceRule(1, 0, 'floor', true),
  createPlaceRule(-1, 0, 'space', true),
]

export const createData = () => {
  addMachine(
    'water-cooler',
    {
      buildName: 'Water Cooler',
      buildDesc: 'Place to relieve thirst',
      frames: [frameInfo.fi32(5, 1, 7), frameInfo.fi32(5, 2, 7)],
    },
    x1x2,
  )
  addMachine(
    'ice-melter',
    {
      buildName: 'Ice Melter',
      buildDesc: 'Convert ice to water',
      frames: [frameInfo.fi32(5, 3, 4)],
    },

    x4x2,
    [
      {
        name: 'input',
        oi: 0,
        oj: 0,
        frames: [frameInfo.fi32(5, 3, 4)],
      },
    ],
  )
  addMachine(
    'suits',
    {
      buildName: 'Spacesuit Holder',
      buildDesc: 'Put on and take off spaceuits',
      frames: [frameInfo.fi32(5, 3, 6), frameInfo.fi32(5, 3, 7)],
    },

    x1x2,
    [
      {
        name: 'core',
        oi: 0,
        oj: 0,
        frames: [frameInfo.fi32(5, 3, 6), frameInfo.fi32(5, 3, 7)],
      },
    ],
  )
  addMachine(
    'airlock',
    {
      buildName: 'Airlock',
      buildDesc: 'Enter or exit the ship here',
      frames: [frameInfo.fi32(5, 4, 7)],
    },
    x2x2,
  )

  addMachine(
    'grower',
    {
      buildName: 'Personal Hydroponics Bay',
      buildDesc: 'Grow some food',
      frames: [
        frameInfo.fi32(5, 12, 1),
        frameInfo.fi32(5, 12, 2),
        frameInfo.fi32(5, 12, 3),
        frameInfo.fi32(5, 12, 4),
        frameInfo.fi32(5, 12, 5),
        frameInfo.fi32(5, 12, 6),
      ],
    },
    x2x2,
  )
  addMachine(
    'bed',
    {
      buildName: 'Bed',
      buildDesc: 'Rest your little head',
      frames: [frameInfo.fi32(5, 4, 5), frameInfo.fi32(5, 4, 6)],
    },
    x2x1,
    [
      {
        oi: 0,
        oj: 0,
        frames: [frameInfo.fi32(8, 21, 2), frameInfo.fi32(8, 22, 2)],
      },
      {
        oi: 1,
        oj: 0,
        frames: [frameInfo.fi32(8, 21, 3), frameInfo.fi32(8, 22, 3)],
      },
    ],
  )
  addMachine(
    'table',
    {
      buildName: 'Table',
      buildDesc: 'Gathering place for idle peeps',
      frames: [frameInfo.fi32(5, 4, 2)],
    },
    x2x2,
  )

  addMachine(
    'o2gen',
    {
      buildName: 'Oxygen Generator',
      buildDesc: 'Converts water to oxygen',
      frames: [
        frameInfo.fi32(5, 16, 1),
        frameInfo.fi32(5, 16, 2),
        frameInfo.fi32(5, 16, 3),
        frameInfo.fi32(5, 16, 4),
      ],
    },
    x2x2,
  )
  addMachine(
    'o2gen-em',
    {
      buildName: 'Oxygen Generator (Emergency)',
      buildDesc: 'Contains a limited amout of O2',
      frames: [frameInfo.fi32(8, 11, 2)],
      allowBuild: false,
    },
    x1x2,
  )

  addMachine(
    'co2scrubber',
    {
      buildName: 'Carbon Dioxide Scrubber',
      buildDesc: 'Removes carbon dioxide from the air',
      frames: [frameInfo.fi32(5, 1, 12)],
    },
    x2x2,
  )

  addMachine(
    'reactor-em',
    {
      buildName: 'Reactor (Emergency)',
      buildDesc: 'Provides limited power',
      frames: [frameInfo.fi32(5, 13, 2), frameInfo.fi32(5, 13, 3)],
      allowBuild: false,
    },
    x2x2,
  )

  addMachine(
    'reactor',
    {
      buildName: 'Reactor',
      buildDesc: 'Provides limited power',
      frames: [frameInfo.fi32(5, 13, 2), frameInfo.fi32(5, 13, 3)],
    },
    x4x2,
  )

  addMachine(
    'engine',
    {
      buildName: 'Engine',
      buildDesc: 'Provides evasion and travel ability',
      frames: [frameInfo.fi32(5, 18, 3)],
      ox: 0,
    },
    xEngine,
    [
      {
        name: 'output',
        oi: -1,
        oj: 0,
        frames: [frameInfo.fi32(5, 18, 2)],
      },
      {
        name: 'core',
        core: true,
        oi: 0,
        oj: 0,
        frames: [frameInfo.fi32(5, 18, 3)],
      },
      {
        name: 'input',
        oi: 1,
        oj: 0,
        frames: [frameInfo.fi32(5, 18, 4)],
      },
    ],
  )

  addMachine(
    'door',
    {
      buildName: 'Door',
      buildDesc: 'Opens and closes',
      frames: [frameInfo.fi32(8, 14, 2)],
    },
    door,
    [
      {
        name: 'top',
        oi: 0,
        oj: -1,
        frames: [frameInfo.fi32(8, 14, 2)],
      },
      {
        name: 'bottom',
        core: true,
        oi: 0,
        oj: 0,
        frames: [frameInfo.fi32(8, 15, 2)],
      },
    ],
  )

  addMachine(
    'airlock2',
    {
      buildName: 'Airlock',
      buildDesc: 'Barrier between space and ship',
      frames: [frameInfo.fi32(8, 12, 2)],
    },
    airlock,
    [
      {
        name: 'top-left',
        oi: -1,
        oj: -1,
        frames: [frameInfo.fi32(8, 12, 2)],
      },
      {
        name: 'bottom-left',
        oi: -1,
        oj: 0,
        frames: [frameInfo.fi32(8, 13, 2)],
      },
      {
        name: 'top-right',
        oi: 1,
        oj: -1,
        frames: [frameInfo.fi32(8, 12, 2)],
      },
      {
        name: 'bottom-right',
        oi: 1,
        oj: 0,
        frames: [frameInfo.fi32(8, 13, 2)],
      },
    ],
  )

  addMachine(
    'pile',
    {
      buildName: 'Pile',
      buildDesc: 'A small stack',
      frames: [frameInfo.fi32(8, 16, 2)],
      stackMaxSize: 5,
      isStack: true,
      buildRequirements: [],
    },
    x1x1,
  )

  addMachine(
    'stack',
    {
      buildName: 'Stack',
      buildDesc: 'A larger stack',
      frames: [frameInfo.fi32(8, 17, 2)],
      stackMaxSize: 9,
      isStack: true,
    },
    x1x2,
    [
      {
        name: 'top',
        oi: -1,
        oj: -1,
        frames: [frameInfo.fi32(8, 17, 2)],
      },
      {
        name: 'bottom',
        oi: -1,
        oj: 0,
        frames: [frameInfo.fi32(8, 18, 2)],
      },
    ],
  )
}
